module.exports = "../images/fishing-lodge-06.jpg?v=0c52cc2";